import { augmentedRealityStart, infoGetOS, augmentedRealityGetVersion } from './JS2NativeInterface';
import Vue from 'vue';
import store from '@/store';
import errorHandler from './errorHandler';
import { actionTypes, errorTypes } from '@/types';
import { logger } from '@/tools';
import router from '@/router';

export default async function(arRootURL) {
	const { currentLanguage } = store.getters;
	const { currentAugmentedRealityArticle } = store.state;

	let data = {};
	try {
		const result = await Vue.http.get(`${arRootURL}/index.json`);
		if (result.error) {
			errorHandler(new Error(errorTypes.arDescriptionNotLoaded));
			return null;
		}
		data = JSON.parse(
			JSON.stringify(result.body).replace(/\*SYSTEM\*/g, (await infoGetOS()).toLowerCase())
		);

		// TODO: Include fallback langauge filterting
		if (data.AssetbundleProperties) {
			data.Prefab.forEach(prefab => {
				if (prefab.markerPath) prefab.markerPath = `${arRootURL}/${prefab.markerPath}`;
				if (prefab.modelPath) {
					prefab.modelPath = prefab.modelPath
						.split(';')
						.map(path => `${arRootURL}/${path}`)
						.join(';');
				}
				prefab.I18nGameobject.forEach(gameObject => {
					gameObject.I18nText = gameObject.I18nText
						? gameObject.I18nText.filter(text => text.languageISO === currentLanguage)
						: gameObject.I18nText;
				});
			});
			data.I18nInstruction = data.I18nInstruction
				? data.I18nInstruction.filter(instruction => instruction.languageISO === currentLanguage)
				: data.I18nInstruction;
		}
		// else {
		// data.markerModelList.forEach(model => {
		// 	if (model.markerXmlURL) model.markerXmlURL = new URL(model.markerXmlURL, arRootURL).toString();
		// 	if (model.modelLOD0URL) model.modelLOD0URL = new URL(model.modelLOD0URL, arRootURL).toString();
		// 	if (model.modules) {
		// 		model.modules.forEach(module => {
		// 			switch (module.moduleName) {
		// 				case 'VideoModule':
		// 					if (module.moduleConfig && module.moduleConfig.contentBaseUrl) {
		// 						module.moduleConfig.contentBaseUrl = new URL(
		// 							module.moduleConfig.contentBaseUrl,
		// 							arRootURL
		// 						).toString();
		// 					}
		// 					break;
		// 				case 'TextModule':
		// 					if (
		// 						module.moduleConfig &&
		// 						module.moduleConfig.textFile &&
		// 						module.moduleConfig.textFile.url
		// 					) {
		// 						module.moduleConfig.textFile.url = new URL(
		// 							module.moduleConfig.textFile.url,
		// 							arRootURL
		// 						).toString();
		// 					}
		// 					break;
		// 				default:
		// 					logger.log('augmentedRealitySetArticle: Unkown ar module ', module);
		// 			}
		// 		});
		// 	}
		// });
		// }
	} catch (error) {
		errorHandler(new Error(errorTypes.augmentedRealityIndexDownloadFailed), {
			templateData: { ERROR: `${error}` },
		});
		router.back();
		return;
	}
	// AR engine vs. asset version comparison
	const arEngineVersion = await augmentedRealityGetVersion();
	const assetArEngineVersion = data.AssetbundleProperties.arEngineVersion;

	if (
		(typeof arEngineVersion === 'undefined' && typeof assetArEngineVersion !== 'undefined') ||
		(typeof arEngineVersion !== 'undefined' &&
			typeof assetArEngineVersion !== 'undefined' &&
			arEngineVersion != assetArEngineVersion)
	) {
		return errorHandler(errorTypes(errorTypes.augmentedRealityEngineVersionMissmatch));
	}
	// Add matomo analytics
	data.analyticsInfo = {};
	const matomoTracker = window.Piwik && window.Piwik.getAsyncTracker();
	if (matomoTracker) {
		data.analyticsInfo = {
			baseURL: matomoTracker.getPiwikUrl(), // the base URL of the tracking system like https://athena.cms.shoutrlabs.com/etna/
			siteId: matomoTracker.getSiteId(),
			url: window.location.href, // the url of the requested ar article
			userId: matomoTracker.getVisitorId(), // the unique user id
		};
	}

	data.PlayingMediaObjects = {};
	if (store.state.playerAudio.playerState == 'playing') {
		const { mediaID, title, description, source, duration, currentTime } = store.state.playerAudio;
		data.PlayingMediaObjects = {
			id: mediaID,
			type: 'audio',
			I18nContent: [{ languageISO: currentLanguage, title, description, source, duration }],
			position: currentTime,
		};
		store.dispatch(actionTypes.audioClose);
	}
	data.ArticleLanguageContent = currentAugmentedRealityArticle.languageContent.filter(
		lc => lc.languageISO === currentLanguage
	);
	data.ExternalMediaObjects = currentAugmentedRealityArticle.arContent.externalMediaObjects.map(
		mediaObject =>
			Object.assign({}, mediaObject, {
				languageContent: mediaObject.languageContent
					.filter(lc => lc.languageISO === currentLanguage)
					.map(lc =>
						Object.assign({}, lc, {
							sourceUrl: `${store.state.dataSourceURL}apps/${
								mediaObject.type === 'image' ? `media-${lc.source}/1024` : lc.sourceUrl
							}`,
						})
					),
			})
	);
	logger.log('Augmented reality data: ', JSON.stringify(data).replace(/\"/g, '"'));
	logger.log(`"${JSON.stringify(data).replace(/"/g, '\\"')}"`);
	console.log('Augmented reality data:'); // remove when nativeAppDoLog works
	console.log(`"${JSON.stringify(data).replace(/"/g, '\\"')}"`);
	await augmentedRealityStart(JSON.stringify(data));
}
